<div class="q-box" (click)="panelOpenState = !panelOpenState">
  <span class="questionQ">Q : </span><span class="question">{{faqItem.question}}</span>

  <div [@showFAQ] class="a-box" *ngIf='panelOpenState' id="{{faqItem.id}}">
    <span class="answerA">A : </span><span class="answer">{{faqItem.answer}}</span>
  </div>
</div>
